import { render, staticRenderFns } from "./ownerManagerView.vue?vue&type=template&id=2b317cae&scoped=true&"
import script from "./ownerManagerView.vue?vue&type=script&lang=js&"
export * from "./ownerManagerView.vue?vue&type=script&lang=js&"
import style0 from "./ownerManagerView.vue?vue&type=style&index=0&id=2b317cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b317cae",
  null
  
)

export default component.exports